'use client';
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref) {
        ref.current = value;
    }
}
/**
 *
 * @param refs
 *
 * Example
 * (props, ref) => {
 *   const tempRef = useRef()
 *
 *   onX = () => {
 *     tempRef.current.some_work()
 *   }
 *
 *   return <div ref={assignRefs(ref, tempRef)} />
 *
 *   return renderElem({
 *      baseElement: 'div'
 *      ref: assignRefs(ref, tempRef)
 *      ...other_stuff
 *   })
 * }
 */ function assignRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>assignRef(ref, value));
    };
}

export { assignRef, assignRefs };
